/* eslint-disable import/no-unresolved */
/* eslint-disable react/destructuring-assignment */
import {
  Box, Button, CardContent, CircularProgress, TextField, Typography,
} from '@mui/material'
import { useEffect, useState } from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useFormik } from 'formik';
import PhoneInput from 'react-phone-input-2';
import { IFiles } from '../../../../config/interfaces';
import DropZone from './dropzone';
import ListFiles from '../../dropzone/listFiles';
import { Location } from '../../../../../graphql/generated/graphql';
import { FormSchema } from './schema';
import './index.scss';
import AddresField from './AddresField';

const initialValues: Location = {
  id: '',
  name: '',
  set_address: '',
  zipcode: '',
  parking_address: '',
  parking_instructions: '',
  nearest_hospital_address: '',
  location_notes: '',
  location_contact: '',
};

const LocationForm = (props: any) => {
  const { item } = props;
  const [files, setFiles] = useState<Array<IFiles>>([]);
  const [filesToDelete, setFilesToDelete] = useState<Array<string>>([]);
  const [changeStateFile, setChangeStateFile] = useState<boolean>(false);
  const handleZone = (data: string, name: string, size: number) => {
    const row = {
      name,
      base64: data,
      size,
    };
    setFiles((prevArray) => [...prevArray, row]);
  }

  const removeFile = (file: IFiles) => {
    setChangeStateFile(true);
    setFiles(files.filter(((f: IFiles) => f.name !== file.name)));
    setFilesToDelete([...filesToDelete, file.id!])
  }

  const formik = useFormik({
    initialValues,
    validationSchema: FormSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (item) {
      formik.setValues(item);
      if (item.files && item.files.length > 0) {
        setFiles(item.files);
      } else {
        setChangeStateFile(true);
      }
    }
  }, [item]);

  const handleSubmit = (e: any) => {
    if (formik.isValid) {
      if (item) {
        props.handleSubmitEdit(formik.values, files, filesToDelete, changeStateFile);
      } else {
        props.handleSubmit(formik.values, files);
      }
    }
  }

  const handleParkingAddress = (value: any) => {
    formik.setFieldValue('parking_address', value)
  }

  const handleAddress = (value: any) => {
    formik.setFieldValue('set_address', value)
  }

  const handleHospitalAddress = (value: any) => {
    formik.setFieldValue('nearest_hospital_address', value)
  }


  return (
    <Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <LocationOnIcon fontSize="large" color="primary" />
        <Typography component="h1" variant="h3" sx={{ fontWeight: 500, mt: 2 }}>
          {item ? 'Edit Shoot Location' : 'Create New Shoot Location'}
        </Typography>
      </Box>
      <CardContent>
        <TextField
          margin="normal"
          sx={{
            mt: 1,
          }}
          required
          fullWidth
          inputProps={{ maxLength: 50 }}
          id="name"
          label="Location Name"
          name="name"
          autoComplete="name"
          autoFocus
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
        <AddresField
          value={formik.values.set_address}
          formik={formik}
          handleFormik={handleAddress}
          field='set_address'
          fieldPostalCode='zipcode'
          label='Address'
          searchPostalCodeFromAddres
        />
        <AddresField
          value={formik.values.parking_address as string}
          formik={formik}
          handleFormik={handleParkingAddress}
          field='parking_address'
          label='Parking Address'
        />
        <TextField
          margin="normal"
          fullWidth
          sx={{
            mt: 1,
          }}
          name="parking_instructions"
          label="Parking Instructions"
          id="parking_instructions"
          inputProps={{ maxLength: 50 }}
          value={formik.values.parking_instructions}
          onChange={formik.handleChange}
          error={formik.touched.parking_instructions && Boolean(formik.errors.parking_instructions)}
          helperText={formik.touched.parking_instructions && formik.errors.parking_instructions}
        />
        <AddresField
          value={formik.values.nearest_hospital_address as string}
          formik={formik}
          handleFormik={handleHospitalAddress}
          field='nearest_hospital_address'
          label='Nearest Hospital Address'
        />
        <PhoneInput
          country="us"
          containerStyle={{
            marginTop: '16px'
          }}
          value={formik.values.location_contact}
          onChange={(value) => {
            formik.handleChange({ target: { name: 'location_contact', value } });
          }}
          enableSearch
          specialLabel="Location Contact"
          inputProps={{
            name: 'location_contact',
            id: 'location_contact',
          }}
        />
        <TextField
          margin="normal"
          fullWidth
          sx={{
            mt: 2,
          }}
          name="location_notes"
          label="Location Notes"
          id="location_notes"
          inputProps={{ maxLength: 50 }}
          value={formik.values.location_notes}
          onChange={formik.handleChange}
          error={formik.touched.location_notes && Boolean(formik.errors.location_notes)}
          helperText={formik.touched.location_notes && formik.errors.location_notes}
        />
        {files.length < 1 && <DropZone handleZone={handleZone} />}
        <ListFiles files={files} removeFile={removeFile} />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 2, mb: 0 }}
          disabled={!(formik.isValid && formik.dirty) || props.loading}
          onClick={(e: any) => handleSubmit(e)}
        >
          {
            (() => {
              if (props.loading) {
                return <CircularProgress color="secondary" size={20} />
              }
              if (item) {
                return 'Edit Shoot Location'
              }
              return 'Create Shoot Location'
            })()
          }
        </Button>
      </CardContent>
    </Box>
  )
}

export default LocationForm;
